import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicDestinyApartments from "../Components/ProjPicDestinyApartments";

const ProjectPageDestinyApartments = () => {
    return (
        <>
            <Navbar />
            <ProjPicDestinyApartments />
            <Footer />
        </>
    );
};

export default ProjectPageDestinyApartments;
